import React, { useEffect, useState } from 'react';
import { useLoading } from '../../contexts/LoadingContext';
import { useTheme } from '../../contexts/ThemeContext';
import LoadingSpinner from '../LoadingSpinner/LoadingSpinner';

const SHOW_DELAY_MS = 400;

const GlobalLoading: React.FC = () => {
  const { isLoading } = useLoading();
  const { colors } = useTheme();
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    if (!isLoading) {
      setVisible(false);
      return;
    }
    const timer = window.setTimeout(() => setVisible(true), SHOW_DELAY_MS);
    return () => window.clearTimeout(timer);
  }, [isLoading]);

  if (!visible) {
    return null;
  }

  return (
    <div className={`fixed inset-0 ${colors.background} bg-opacity-90 z-50 flex items-center justify-center`}>
      <LoadingSpinner fullScreen={false} message="Loading..." size="large" />
    </div>
  );
};

export default GlobalLoading;

